// Baseball pitch types
export const baseballPitchTypes = [
  "Fastball",
  "Sinker",
  "Cutter",
  "Changeup",
  "Curveball",
  "Slider",
  "Splitter",
  "Knuckleball",
];

// Softball pitch types
export const softballPitchTypes = [
  "Fastball",
  "Dropball",
  "Riseball",
  "Curveball",
  "Screwball",
  "LowRise",
  "Changeup",
  "Offspeed",
];

// Helper function to get pitch types by sport
export const getPitchTypeOptions = (isSoftball: boolean): string[] => {
  return isSoftball ? softballPitchTypes : baseballPitchTypes;
};
